import React, {ImgHTMLAttributes} from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

interface ClearIconProps extends ImgHTMLAttributes<any> {
}

const ClearIcon = ({...props}: ClearIconProps) => {
  return (
    <img
      src={toAbsoluteUrl('/media/common/Cross_primary.svg')}
      alt="clear"
      className={styles.clearIcon}
      {...props}
    />
  );
};

export default ClearIcon;